module.exports = __webpack_public_path__ + "img/53.ef05e86e.png";